import React, { useState, useMemo, useEffect } from 'react'
import PrimaryModal from '../../UI/Modal/PrimaryModal'
import { getAllContentfulIntegration } from '../../../utils/APIs';
import Loader from '../../UI/Loader/Loader';
import { toast } from 'react-toastify';
import { useUserContext } from '../../../contexts/UserContext';
import { useContentfulContext } from '../../../contexts/ContentfulContext';
import AgGridWrapper from '../../UI/AgGrid';

const ContentfulIntegrationModal = ({handleClose}) => {

    const [loading, setLoading] = useState(false);
    const [adobeData, setAdobeData] = useState([]);
    const [selectedItem, setSelectedItem] = useState();
    const [gridApi, setGridApi] = useState(null);

    const { userData, updateDefaultContentful } = useUserContext();
    const { content } = useContentfulContext();

    useEffect(() => {
        getContentfulIntegrationHandler()
    }, [])

    const getContentfulIntegrationHandler = async () => {
        try {
            setLoading(true);
            const contentfulIntegrations = await getAllContentfulIntegration(userData.token, userData.selectedOrganization.org_token);
            const updated = contentfulIntegrations.data.map((x) => ({
                ...x,
                default: userData.defaultContentful?._id == x._id ? true : false
            }))
            setAdobeData(updated);
            // Set the default selected item
            const defaultItem = updated.find((item) => item.default);
            if (defaultItem) setSelectedItem(defaultItem);
        } catch (error) {
            toast.error(error?.message || content?.COMMON_MESSAGE.something_wrong_msg);
        } finally {
            setLoading(false);
        }
    };

    const handleRowSelected = (event) => {
        const selectedRow = event.data;
        if (selectedItem?._id !== selectedRow._id) {
            setSelectedItem(selectedRow);
            toast.success(content.GLOBAL_SELECTOR_CONTENT.contentful.success_msg);
            updateDefaultContentful(selectedRow);
        }
    };

    const CheckboxRenderer = (params) => {
        const isChecked = selectedItem?._id === params.data._id;
        return (
            <input
                type="checkbox"
                checked={isChecked}
                onChange={() => handleRowSelected(params)}
                className="cursor-pointer rounded-lg w-4 h-4"
            />
        );
    };

    const colDefs= [
        {
            headerName: "",
            field: "checkbox",
            cellRenderer: CheckboxRenderer,
            suppressMovable: true,
        },
        {   headerName: content.GLOBAL_SELECTOR_CONTENT.contentful.table.integration_name, 
            field: "name", 
            cellRenderer: ({ data }) => (
                <button className='text-center block cursor-pointer text-primary'>{data.name}</button>
            ),
            filter: true,
            sortable: true,
            suppressMovable: true,
            resizable: false
        },
        { 
            headerName: content.GLOBAL_SELECTOR_CONTENT.contentful.table.environments,
            field: "environments",
            cellRenderer: ({ data }) => {
                return <div class="relative inline-block">
                    { data.environments?.join(', ') }
                </div>;
            },
            resizable: false,
            suppressMovable: true,
        },
    ];

    const onGridReady = (params) => {
        setGridApi(params.api);
    };

    const autoSizeStrategy = useMemo(() => {
        return {
          type: "fitGridWidth",
          defaultMinWidth: 40,
          columnLimits: [
            {
                colId: "checkbox",
                minWidth: 40,
            },
            {
                colId: "name",
                minWidth: 300,
            },
            {
                colId: "environments",
                minWidth: 350,
            },
          ],
        };
    }, []);

    const onFirstDataRendered = (params) => {
        if (adobeData.length > 0) {
            const defaultRow = adobeData.find((row) => row.default);
            if (defaultRow) {
                setSelectedItem(defaultRow);
            }
        }
    };

    const onFilterTextBoxChanged = (event) => {
        const filterValue = event.target.value.toLowerCase();
        gridApi.setFilterModel({
            name: { type: 'contains', filter: filterValue }
        });
    };

    return (
        <PrimaryModal
            title={content.GLOBAL_SELECTOR_CONTENT.contentful.title}
            hideModal={() => selectedItem && handleClose()}
            widthClass="max-w-5xl"
        >
            {loading && <Loader />}
            <div className="p-7 pt-1 space-y-6">
                <p>{content.GLOBAL_SELECTOR_CONTENT.contentful.description}</p>
                <div className='flex justify-between items-center'>
                    <input
                        type="text"
                        className='block px-2.5 py-2.5 w-full text-sm text-gray-900 bg-transparent rounded-lg border border-gray-2 appearance-none focus:outline-none max-w-64'
                        placeholder="Search by name"
                        onChange={onFilterTextBoxChanged}
                    />
                </div>
                <div className={"ag-theme-quartz"} style={{ height: "100%", width: "100%" }} >
                    <AgGridWrapper
                        tableId="global-selector-contentful-integration-table"
                        rowData={adobeData}
                        columnDefs={colDefs}
                        autoSizeStrategy={autoSizeStrategy}
                        onGridReady={onGridReady}
                        onFirstDataRendered={onFirstDataRendered}
                        rowSelection="single"
                        suppressRowClickSelection
                        onRowSelected={handleRowSelected}
                    />
                </div>
            </div>
        </PrimaryModal>
    )
}

export default ContentfulIntegrationModal

